// extracted by mini-css-extract-plugin
export default {"ResponsiveMedia":"ResponsiveMedia-module__ResponsiveMedia___1NPpv"};